export default __webpack_public_path__ + "static/media/graph-billing.b9f0ef12.svg";